import { Component, computed, inject, input, signal } from '@angular/core'
import { RouterLink } from '@angular/router'
import { LocalStorageAccessService } from '@app/core/_services/local-storage-access.service'
import { UserService } from '@app/core/_services/user.service'

const STORAGE_KEY = 'bookingHub:quietModeMatchHintDismissed' as const

@Component({
    selector: 'fm-booking-hub-quiet-mode-match-hint',
    standalone: true,
    imports: [RouterLink],
    templateUrl: './booking-hub-quiet-mode-match-hint.component.html',
})
export class BookingHubQuietModeMatchHintComponent {
    /** Mirrors booking quiet mode toggle (session preference). */
    quietMode = input<boolean>(false)

    private readonly userService = inject(UserService)
    private readonly localStorageAccessService = inject(LocalStorageAccessService)

    private readonly dismissed = signal(false)

    constructor() {
        const stored = this.localStorageAccessService.getItem(STORAGE_KEY)
        this.dismissed.set(stored === 'true')
    }

    readonly visible = computed(() => {
        if (this.dismissed()) {
            return false
        }
        if (this.quietMode()) {
            return false
        }
        const user = this.userService.currentUserSig()
        const permissive = user?.settings?.quietModeMatchAllowed ?? true
        return permissive === true
    })

    dismiss(): void {
        this.localStorageAccessService.setItem(STORAGE_KEY, 'true', 'bookingHub')
        this.dismissed.set(true)
    }
}
